import React from "react";
import {useNavigate} from 'react-router-dom';
import {Colors} from "../../assets/Colors";

const LayananMandiri = ({}) => {
    const navigate = useNavigate();
    let user = JSON.parse(localStorage.getItem("user"));
    return (
        <div className="md:ml-64">
            <div className="w-full flex flex-col items-center">
                <div className="w-full px-4 my-4 ">
                    <div style={{borderColor: Colors.primary}} className="flex flex-col border rounded">
                        <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                            <div onClick={() => navigate('/cuti-mandiri')} className="w-full md:w-1/4 cursor-pointer">
                                <div style={{borderColor: Colors.primary}}
                                     className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded">
                                    <p className="pl-2">Cuti</p>
                                </div>
                            </div>
                            <div onClick={() => navigate('/izin-mandiri')} className="w-full md:w-1/4 cursor-pointer">
                                <div style={{borderColor: Colors.primary}}
                                     className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded">
                                    <p className="pl-2">Izin</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LayananMandiri;
